import React from 'react';

import { Container } from './styles';

interface INotificationBadgeProps {
  count: number;
}

const NotificationBadge: React.FC<INotificationBadgeProps> = ({
  count,
}: INotificationBadgeProps) => {
  return <Container>{count}</Container>;
};

export default NotificationBadge;
